import * as React from "react"
import { Market, Selection } from "../../../../../../contracts";
import { BetBtnAmerican } from "../../../../components";
import { MarketTemplate } from "../../../../../../data";
import { isMarketType, getDictPhrase } from "../../../../../../helpers";

export const renderBetButtonsAmerican = (market: Market, betButtonHandler: (market: Market, selection: Selection) => void, componentPrefix: string, isTeamSwap: boolean, dict: any, isDesktop: boolean) => {
    const selections = prepareSelections(isTeamSwap, market);

    return (
        <div key={`${componentPrefix}__${market.id}`} className={`rj-ev-list__ev-card__section rj-ev-list__ev-card__section--${market.template}`} data-uat={`div-ev-list-${componentPrefix}-section`}>
            {selections && selections.map(
                (s, index) => {
                    let betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
                    let displayText = getDisplayText(dict, market, s, isDesktop);

                    return (
                        <BetBtnAmerican
                            key={`${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`}
                            isDisabled={s.isDisabled}
                            classNames={`${betslipModifier}`}
                            handler={() => betButtonHandler(market as Market, s as Selection)}
                            text={displayText}
                            point={s.pointsText}
                            odd={s.odds}
                            trueOdds={s.trueOdds}
                        />
                    )
                }
            )}
        </div>
    );
}

const getDisplayText = (dict: any, market: Market, selection: Selection, isDesktop: boolean): string => {
    if (!selection.outcomeType) {
        return "";
    }

    if (isMarketType(market.marketType.id, "ML") && !isDesktop) {
        return getDictPhrase(dict,`AmericanBtnML${selection.outcomeType}`);
    }
    if (isMarketType(market.marketType.id, "OU")) {
        return getDictPhrase(dict, `AmericanBtn${selection.outcomeType}`);
    }

    return "";
}

const prepareSelections = (isTeamSwap: boolean, market: Market): Selection[] => {
    if (isMarketType(market.marketType.id, "ML") || isMarketType(market.marketType.id, "HC")) {
        let orderedSelections: Selection[] = isTeamSwap ? market.selections.slice().reverse() : market.selections.slice();
        if (market.template === MarketTemplate.ThreeBox) {
            let drawSelection: Selection = orderedSelections.splice(1, 1)[0];
            orderedSelections.push(drawSelection);
        }
        return orderedSelections;
    }
    return market.selections;
}